import {useContext} from 'react'
import {SalesRepReportContext} from '../../context'
import Select from '../../../../components/Select/Select'
import Search from '../../../../components/Search'
import {useAppSelector} from '../../../../redux/useTypedSelector'
import {hasAccess} from '../../utils'

const SalesRepReportHeader = () => {
  const {user} = useAppSelector((state) => state.auth)
  const {onSearch, onSalesRepFilterChange, Representatives, RepresentativesLoading} =
    useContext(SalesRepReportContext)
  const accessPermissions = hasAccess(Representatives, user)

  return (
    <div className='d-flex align-items-center gap-5 flex-wrap mb-10'>
      <Search onSearch={(value: string) => onSearch(value)} />
      <Select
        id='sales_rep'
        options={Representatives}
        isLoading={RepresentativesLoading}
        placeholder='Representative: All'
        isNullable={true}
        onChange={(e: any) => onSalesRepFilterChange(e.target.value)}
        defaultValue={accessPermissions?.repEmail || ''}
        disabled={accessPermissions.repEmail}
      />
    </div>
  )
}

export default SalesRepReportHeader
